export const ListQueryKey = 'activitySubActivitys';
export const DetailQueryKey = 'activitySubActivity';
export const Urls = {
  selectUrl: '/subActiveConfig/list',
  updateUrl: '/subActiveConfig/update',
  deleteUrl: '/subActiveConfig/delete',
  createUrl: '/subActiveConfig/create',
  detailUrl: '/subActiveConfig/detail'
}; // /api/subActiveConfig/list